module.exports = __webpack_public_path__ + "img/Approve_Popup.6370f39e.png";